/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useReducer } from 'react';
import { AlertType } from 'models';
import Notification from 'components/mainComponents/Notification';

type State = {
  isOpen: boolean;
  type: AlertType;
  message: string;
};

type Action =
  | {
      type: 'hide';
    }
  | {
      type: 'display';
      payload: {
        isOpen: boolean;
        type: AlertType;
        message: string;
      };
    };

type Context = {
  state: State;
  dispatch: React.Dispatch<Action>;
  displayNotification: (type: AlertType, message: string) => void;
};

const initialState: State = {
  isOpen: false,
  type: undefined,
  message: '',
};

const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case 'display': {
      const { isOpen, type, message } = action.payload;
      return { ...state, isOpen, type, message };
    }
    case 'hide': {
      return { ...initialState };
    }
    default:
      return { ...state };
  }
};

export const NotificationContext = React.createContext<Context>({
  state: initialState,
  dispatch: () => {},
  displayNotification: () => {},
});

export const NotificationContextProvider = ({ children }: any): JSX.Element => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const handleClose = (): void => {
    dispatch({ type: 'hide' });
  };

  const displayNotification = (type: AlertType, message: string): void => {
    dispatch({
      type: 'display',
      payload: { isOpen: true, type, message },
    });
  };

  return (
    <NotificationContext.Provider
      value={{
        state,
        dispatch,
        displayNotification,
      }}
    >
      <Notification
        isOpen={state.isOpen}
        type={state.type}
        message={state.message}
        onClose={handleClose}
      />
      {children}
    </NotificationContext.Provider>
  );
};
